import React from "react";
import "./PrivacyPolicy.css";

const PrivacyPolicy = () => {
  return (
    <div className="privacy-containerx">
      <div className="privacy-cardx">
        <h1 className="privacy-titlex">Privacy Policy</h1>

        <section>
          <h2>1. Information We Collect</h2>
          <p>We may collect:</p>
          <ul>
            <li>Name, phone number, email, and address</li>
            <li>Payment details (if you make a donation or payment)</li>
            <li>Messages, feedback, or queries you send us</li>
            <li>
              Basic technical data like IP address, browser type, and pages
              visited (via cookies)
            </li>
          </ul>
        </section>

        <section>
          <h2>2. How We Use Your Information</h2>
          <p>We use your information to:</p>
          <ul>
            <li>Provide and improve our services</li>
            <li>Respond to your messages and support requests</li>
            <li>Send updates or announcements (only if you agree)</li>
            <li>Process donations or payments</li>
            <li>Meet legal requirements</li>
          </ul>
        </section>

        <section>
          <h2>3. Sharing of Information</h2>
          <p>
            We do not sell your personal information. We may share it only with
            trusted service providers (like website hosting or payment
            services) or if required by law.
          </p>
        </section>

        <section>
          <h2>4. Cookies</h2>
          <p>
            Our website may use cookies to understand how visitors use the site
            and improve performance. You can disable cookies in your browser
            settings.
          </p>
        </section>

        <section>
          <h2>5. Data Protection</h2>
          <p>
            We take reasonable steps to keep your information safe. However, no
            online system is completely secure.
          </p>
        </section>

        <section>
          <h2>6. Children’s Privacy</h2>
          <p>
            Our services are not meant for children under 13. We do not
            knowingly collect their personal information.
          </p>
        </section>

        <section>
          <h2>7. Your Rights</h2>
          <p>
            You may request to access, update, or delete your personal
            information by contacting us.
          </p>
        </section>

        <section>
          <h2>8. Contact Us</h2>
          <p>
            <strong>Islamic Research Centre (IRC)</strong>
          </p>
          <p>Email: islam@irc-india.com</p>
          <p>Phone: 8055455545</p>
          <p>
            Address: H.No 1-23-100, Rohila Gali, Aurangabad - 431001 MH
          </p>
        </section>

        <section>
          <h2>9. Communication Consent</h2>
          <p>
            If you provide your phone number on our forms, you agree to receive
            updates from IRC via SMS, RCS, or WhatsApp related to our
            activities and services.
          </p>
        </section>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
